import { render, staticRenderFns } from "./JackpotGame.vue?vue&type=template&id=67865ed1&"
import script from "./JackpotGame.vue?vue&type=script&lang=js&"
export * from "./JackpotGame.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports